export const SECTION_NAME = "Lot";

export const INTRO_TEXT = `Lot tracking is used to track batches or groups of a specific item.`;

export const EXAMPLE_JSON = `{ 
  "id":123,
  "syncToken":0,
  "starred":0,
  "number":"988CP2382019",
  "item": { 
    "id": 64,
    "name": 'Widget, 1/4"'
  },
  "description":"Lot for Widgets",
  "expiration": "2020-05-08T09:13:00",
  "recalled": false,
  "expired": false,
  "customFields":[ 
    { 
      "id":5,
      "name":"Checkbox",
      "value":"false",
      "dataType":"Boolean"
    }
  ],
  "onhand": 15.00000,
  "available": 20.00000,
  "summaryOnly": false,
}`;

export const ATTRIBUTES = [
  {
    name: "id",
    type: "integer",
    description:
      "Unique identifier for this record. Must not be provided on create transactions.",
  },
  {
    name: "starred",
    type: "integer",
    description: `Indicates if this transaction has been starred. A value of 0 = no star; 1 or 1-3 = starred. Star colors 
      depend on application configuration. This could be one color of star or three colors of stars. See Company Settings in the user guide for more details.`,
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record. If you receive an error when updating a record, it is because your syncToken is for an older version of the record than that which is currently in the database. Please GET the latest version prior to updating.`,
  },
  {
    name: "number",
    type: "string",
    description: `The lot identifier.`,
  },
  {
    name: "item",
    type: "reference",
    description: "The item associated with this lot.",
  },
  {
    name: "description",
    type: "string",
    description: `Description of this lot.`,
  },
  {
    name: "expiration",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS",
    description: `True if lot has expired, false if not.`,
  },
  {
    name: "recalled",
    type: "boolean",
    description: `True if lot has been recalled, false if not.`,
  },
  {
    name: "expired",
    type: "boolean",
    description: `Has this lot expired?`,
    readOnly: true,
  },
  {
    name: "customFields",
    type: "array of custom fields",
    description: `The list of custom fields for this object type.`,
  },
  {
    name: "onhand",
    type: "decimal",
    description: `Quantity of this lot currently in inventory.`,
  },
  {
    name: "available",
    type: "decimal",
    description: `Quantity of this lot currently available for sale.`,
  },
  {
    name: "summaryOnly",
    type: "boolean",
    description: `True if the summary parameter was set when this record was retrieved. False if not.`,
  },
];

export const LINE_ITEM = [];

export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
     The API limits results to a max of 200 results per call.  If you want to retrieve the next set
      of results you can use this parameter to retrive the next set of results.  For example if you
       are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`,
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`,
  },
  {
    name: "query",
    type: "string",
    description: `This parameter will filter the results by matches of the string on the following fields: number, description, or item name.`,
  },
  {
    name: "status",
    type: "string: expired/recalled/notexpirednotrecalled",
    description: `Filters results by whether the transaction is expired or recalled.`,
  },
  {
    name: "archived",
    type: "string: yes/no",
    description: `A "yes" returns archived records only; a "no" returns only those that have not been archived.`,
  },
  {
    name: "location",
    type: "string",
    description: `This parameter will cause the inventory quantity values to reflect the lot totals at this location.`,
  },
  {
    name: "createdsince/updatedsince",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS ",
    description: `Filters transactions created or updated since a specified date/time.`,
  },
];

export const SAMPLE_QUERY_REQUEST =
  "/api/v2/lot?start=101&maxresults=100&createdsince=2019-09-10T00:00:00&updatedsince=2019-09-10T23:59:59";
